import { IconDefinition } from "./types";

const circleInfo: IconDefinition = {
  iconName: "circle-info",
  width: 512,
  height: 512,
  svgPathData:
    "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM216 336l-24 0 0 48 128 0 0-48-32 0 0-112-96 0 0 48 48 0 0 64-24 0zm72-144l0-64-64 0 0 64 64 0z",
  iconType: "fill",
  strokeWidth: 0,
  fontAwesomeName: "circle-info",
  unicode: 0xf05a,
};

export { circleInfo };
